// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.upgrade-container {
    position: relative;
    width: 100%;
    /* height: 100vh; */
    /* overflow-y: scroll; */
    background-color: #ecf8e5;
    padding: 40px 80px;
    /* background-image: url('./../images/paperbg.jpg');
    background-size: cover;
    background-repeat: no-repeat; 
    background-position: center center; */
}

.upgrade-container>p {
    font-size: 18px;
    color: #000;
    font-weight: 600;
}

.upgrade-Upper {
    text-align: center;
}

.upgradeCards {
    margin-top: 50px;
    display: flex;
    justify-content:space-around;

}

.upgrade-btn{
    background-color:"#347571"; 
    color:"white";
    padding:"6px 15px"; 
    border:"none"; 
    border-radius:"25px"; 
    margin-top:"15px";
}

.upgrade-btn:hover{
    background-color: white;
    color: #347571 ;
    border: 1px solid #347571 ;
}

.cards-container{
    padding: 5% 10%;
    padding-top: 2%;
}

@media screen and (max-width: 480px) {
    .upgrade-container {
        padding: 40px 40px;
    }

    .upgradeCards {
        flex-direction: column;
    }

    .card {
        margin-bottom: 20px;
    }
    
    .cards-container {
        padding: 0px;
    }
    
}

@media only screen and (min-width: 480px) and (max-width: 768px) {

    .card {
        margin-right: 20px;
    }
}

.card {
    background-color: white;
    padding: 20px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    border: 1px solid #347571 ;
    

  /* Set the background image URL */

}


.card {
    width: 300px;
    height: 220px;
}

.cardUpper {
    margin-top: 5%;
    text-align: center;
}

.cardBottom {
    /* height: 60%; */
    padding: 20px;
}

.glasss {
    background: rgba(236, 248, 229, 0.042);
    border-radius: 16px;
    box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
    backdrop-filter: blur(3.9px);
    -webkit-backdrop-filter: blur(3.9px);
    border: 1px solid rgba(255, 255, 255, 0.09);
}`, "",{"version":3,"sources":["webpack://./src/styleSheet/Upgrade.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,WAAW;IACX,mBAAmB;IACnB,wBAAwB;IACxB,yBAAyB;IACzB,kBAAkB;IAClB;;;yCAGqC;AACzC;;AAEA;IACI,eAAe;IACf,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,4BAA4B;;AAEhC;;AAEA;IACI,0BAA0B;IAC1B,aAAa;IACb,kBAAkB;IAClB,aAAa;IACb,oBAAoB;IACpB,iBAAiB;AACrB;;AAEA;IACI,uBAAuB;IACvB,eAAe;IACf,0BAA0B;AAC9B;;AAEA;IACI,eAAe;IACf,eAAe;AACnB;;AAEA;IACI;QACI,kBAAkB;IACtB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,YAAY;IAChB;;AAEJ;;AAEA;;IAEI;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI,uBAAuB;IACvB,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,0BAA0B;;;EAG5B,iCAAiC;;AAEnC;;;AAGA;IACI,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,aAAa;AACjB;;AAEA;IACI,sCAAsC;IACtC,mBAAmB;IACnB,yCAAyC;IACzC,4BAA4B;IAC5B,oCAAoC;IACpC,2CAA2C;AAC/C","sourcesContent":[".upgrade-container {\n    position: relative;\n    width: 100%;\n    /* height: 100vh; */\n    /* overflow-y: scroll; */\n    background-color: #ecf8e5;\n    padding: 40px 80px;\n    /* background-image: url('./../images/paperbg.jpg');\n    background-size: cover;\n    background-repeat: no-repeat; \n    background-position: center center; */\n}\n\n.upgrade-container>p {\n    font-size: 18px;\n    color: #000;\n    font-weight: 600;\n}\n\n.upgrade-Upper {\n    text-align: center;\n}\n\n.upgradeCards {\n    margin-top: 50px;\n    display: flex;\n    justify-content:space-around;\n\n}\n\n.upgrade-btn{\n    background-color:\"#347571\"; \n    color:\"white\";\n    padding:\"6px 15px\"; \n    border:\"none\"; \n    border-radius:\"25px\"; \n    margin-top:\"15px\";\n}\n\n.upgrade-btn:hover{\n    background-color: white;\n    color: #347571 ;\n    border: 1px solid #347571 ;\n}\n\n.cards-container{\n    padding: 5% 10%;\n    padding-top: 2%;\n}\n\n@media screen and (max-width: 480px) {\n    .upgrade-container {\n        padding: 40px 40px;\n    }\n\n    .upgradeCards {\n        flex-direction: column;\n    }\n\n    .card {\n        margin-bottom: 20px;\n    }\n    \n    .cards-container {\n        padding: 0px;\n    }\n    \n}\n\n@media only screen and (min-width: 480px) and (max-width: 768px) {\n\n    .card {\n        margin-right: 20px;\n    }\n}\n\n.card {\n    background-color: white;\n    padding: 20px;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    border: 1px solid #347571 ;\n    \n\n  /* Set the background image URL */\n\n}\n\n\n.card {\n    width: 300px;\n    height: 220px;\n}\n\n.cardUpper {\n    margin-top: 5%;\n    text-align: center;\n}\n\n.cardBottom {\n    /* height: 60%; */\n    padding: 20px;\n}\n\n.glasss {\n    background: rgba(236, 248, 229, 0.042);\n    border-radius: 16px;\n    box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);\n    backdrop-filter: blur(3.9px);\n    -webkit-backdrop-filter: blur(3.9px);\n    border: 1px solid rgba(255, 255, 255, 0.09);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
